<div class="page-layout simple fullwidth" *ngIf="oocc">
    <!-- HEADER -->
    <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="row" fxLayoutAlign="start center">
            <button
                mat-icon-button
                class="mr-0 mr-sm-16"
                [routerLink]="'/ordenes-de-compra'"
            >
                <mat-icon>arrow_back</mat-icon>
            </button>

            <div
                fxLayout="column"
                fxLayoutAlign="start start"
                [@animate]="{
                    value: '*',
                    params: { delay: '100ms', x: '-25px' }
                }"
            >
                <div class="h2">OOCC {{ oocc.numero }}</div>

                <div class="subtitle secondary-text">
                    <span>Detalle</span>
                </div>
            </div>
        </div>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->

    <div class="center p-24 pb-56" fusePerfectScrollbar>
        <div class="content">
            <div class="mat-card mat-elevation-z2 p-24" fxLayout="column">
                <mat-tab-group dynamicHeight="true" *ngIf="oocc">
                    <mat-tab label="Orden de compra">
                        <div class="p-24">
                            <app-ficha-oocc
                                [oocc]="oocc"
                                [recepcion]="oocc.recepcion"
                                [idOOCC]="oocc.id"
                                (anularEvent)="anular($event)"
                                (asociarInformeEvent)="asociarDocumento($event)"
                                (guardarRocGesEvent)="guardarRocGes($event)"
                                (bajarDocumentoEvent)="bajarDocumento($event)"
                                (bajarInformeEvent)="bajarInforme($event)"

                                (adjuntarInformeEvent)="adjuntarInforme($event)"
                            ></app-ficha-oocc>
                        </div>
                    </mat-tab>
                    <mat-tab
                        [label]="
                            'Órdenes de Trabajo (' +
                            oocc.ordenesTrabajo.length +
                            ')'
                        "
                    >
                        <div class="p-24">
                            <app-ordenes-trabajo-oocc
                                [ordenesTrabajo]="oocc.ordenesTrabajo"
                            ></app-ordenes-trabajo-oocc>
                        </div>
                    </mat-tab>

                    <mat-tab *ngIf="oocc.factura" label="Factura">
                        <div class="p-24">
                            <app-factura-oocc
                                [factura]="oocc.factura"
                                [origen]="origen"
                                (toggleEstadoFacturaEvent)="
                                    cambiarEstadoFactura($event)
                                "
                            ></app-factura-oocc>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </div>

    <!-- / CONTENT -->
</div>
